module.exports = __webpack_public_path__ + "static/media/help_Disponible.ca8fa8c0.png";